import * as React from "react"
import styled from 'styled-components/macro'
import Title from "../../common/Title";
import Subtitle from "../../common/Subtitle";
import Link from "../../common/Link"
import ExchangeGraphic from '../../images/exchange-graphic-tilted.svg'
import DocumentationGraphic from '../../images/documentation-graphic-tilted.svg'
import UniswapGraphic from '../../images/uniswap-graphic-tilted.svg'
import HarvestFinanceGraphic from '../../images/harvest-finance-graphic-tilted.svg'
import {keyframes} from "styled-components";
import {useState} from "react";

const ComposableSectionWrapper = styled.div`
  width: 100%;
  color: #f9f9f9;
  padding-bottom: 100px;
  padding-top: 100px;
  background: #f4f4ff;
  color: black;
  
  > div {
    max-width: 1050px;
    margin: 0 auto;
  }
  
  @media screen and (max-width: 880px) {
    > div {
      max-width: 480px;
    }
  }
`

const Content = styled.div`
  width: calc(70% - 75px);
  padding: 25px;
  padding-left: 50px;
  margin: 0 auto;
  display: inline-block;
  vertical-align: top;
  margin-right: 0;
  
  @media screen and (max-width: 1100px) {
    width: calc(65% - 75px);
  }
  
  @media screen and (max-width: 880px) {
    width: calc(100% - 40px);
    padding: 25px 20px;
  }
`

const Graphic = styled.div`
  width: 30%;
  display: inline-block;
  vertical-align: top;
  position: relative;
  height: 180px;
  margin-left: 0;
  
  @media screen and (max-width: 1100px) {
    margin-left: 5%;
  }
  
  @media screen and (max-width: 880px) {
    width: 70%;
    margin-left: 15%;
    margin-bottom: 20px;
  }
`

const GraphicImage = styled.div`
  width: 90%;
  position: absolute;
  
  img {
    width: 100%;
  }
  
  :nth-of-type(3) {
    img {
      width: 101%;
      margin-left: -0.5%;
    }
  }
`

const ExchangeAnimation = keyframes`
  from {
    bottom: 26%;
    right: 20%;
    opacity: 0;
  }
  
  4% {
    bottom: 18%;
    right: 12%;
    opacity: 1;
  }
  
  10% {
    bottom: -10%;
    right: 0;
  }
  
  15% {
    bottom: -10%;
    right: 0;
  }
  
  23% {
    bottom: 18%;
    right: 12%;
    opacity: 1;
  }

  32% {
    bottom: 26%;
    right: -5%;
    opacity: 0;
  }
  
  100% {
    bottom: 26%;
    right: -5%;
    opacity: 0;
  }
`

const ShadowAnimation = keyframes`
  /*from {
     filter: drop-shadow( 0 0 0 rgba(0, 0, 0, 1));
  }
  
  45% {
     filter: drop-shadow( 0 0 0 rgba(0, 0, 0, 1));
  }
  
  55% {
    filter: drop-shadow( 14px 26px 3px rgba(0, 0, 0, .2));
  }
  
  65% {
     filter: drop-shadow( 20px 40px 6px rgba(0, 0, 0, .2));
  }
  
  70% {
    filter: drop-shadow( 18px 36px 5px rgba(0, 0, 0, .26));
  }
  
  75% {
    filter: drop-shadow( 20px 40px 6px rgba(0, 0, 0, .2));
  }

  to {
    filter: drop-shadow( 20px 40px 6px rgba(0, 0, 0, .2));
  }*/
`

const ExchangeImage = styled(GraphicImage)`
  z-index: 4;
  bottom: 12%;
  right: 8%;
  
  /*filter: drop-shadow( 0 5px 5px rgba(0, 0, 0, .2)) drop-shadow(0px 8px 10px rgba(0, 0, 0, 0.14)) drop-shadow(0px 3px 14px rgba(0, 0, 0, 0.12));*/
  
  animation-name: ${ExchangeAnimation};
  animation-duration: 15s; 
  animation-timing-function: ease-in-out; 
  animation-delay: 0s;
  animation-direction: normal;
  animation-iteration-count: infinite;
  
  img {
    animation-name: ${ShadowAnimation};
    animation-duration: 5s; 
    animation-timing-function: ease-in-out; 
    animation-delay: 0s;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  
  :nth-of-type(2) {
    animation-delay: -5s;
  }
  
  :nth-of-type(3) {
    animation-delay: -10s;
  }
`

const DocumentationImage = styled(GraphicImage)`
  z-index: 3;
  bottom: -10%;
  right: 0;
`

const ComingSoonText = styled.div`
  color: #606375;
  font-size: 15px;
  line-height: 16px;
  margin-top: 12px;
  display: inline-block;
  vertical-align: top;
`

// markup
const ComposableSection = () => {
  const [clickedComingSoon, setClickedComingSoon] = useState(false)

  return (
    <ComposableSectionWrapper>
      <div>
        <Graphic>
          <ExchangeImage>
            <img src={ExchangeGraphic} />
          </ExchangeImage>
          <ExchangeImage>
            <img src={UniswapGraphic} />
          </ExchangeImage>
          <ExchangeImage>
            <img src={HarvestFinanceGraphic} />
          </ExchangeImage>
          <DocumentationImage>
            <img src={DocumentationGraphic} />
          </DocumentationImage>
        </Graphic>
        <Content>
          <Title>
            Build on Dolomite
          </Title>
          <Subtitle>
            Dolomite is built for other projects to collaborate. Dolomite smart contracts are immutable and non-upgradable, meaning today’s DeFi integrations are future-proof. Using Dolomite as a rock-solid foundation allows other projects to leverage novel features like asset support and DeFi-native Rights retention — helping improve their protocol and strengthen the entire DeFi ecosystem.
          </Subtitle>
          <Link text={'Dive into developer documentation'} dest={'https://docs.dolomite.io/developer-documentation/dolomite-margin-overview'} breakWidth={410} />
        </Content>
      </div>
    </ComposableSectionWrapper>
  )
}

export default ComposableSection
